import { trackEvent } from '@ubeya/shared-web/analytics/amplitude';
import { post } from '../../utils/http';

export const addSchedule = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  slotId,
  employeeId,
  notes,
  isConfirmed,
  isShiftConfirmed,
  bypassComplianceWarnings
}) => {
  trackEvent('Scheduling Board - Add Schedule', {
    accountId,
    branchId,
    projectId,
    shiftId,
    slotId,
    employeeId,
    bypassComplianceWarnings
  });
  return post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/booking`, {
    slotId,
    employeeId,
    notes,
    isConfirmed,
    isShiftConfirmed,
    bypassComplianceWarnings
  });
};
export const addSchedulesShift = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  employeeIds,
  bookToLinkedShifts,
  bypassComplianceWarnings
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/booking/bulk`, {
    employeeIds,
    bookToLinkedShifts,
    bypassComplianceWarnings
  });
